var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,91.764706%,16.862745%)",
      fillOpacity: 1
    },
    d: "M 32.777344 20 C 32.777344 27.058594 27.058594 32.777344 20 32.777344 C 12.941406 32.777344 7.222656 27.058594 7.222656 20 C 7.222656 12.941406 12.941406 7.222656 20 7.222656 C 27.058594 7.222656 32.777344 12.941406 32.777344 20 Z M 32.777344 20 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 28.109375 23.132812 C 28.113281 23.988281 27.949219 24.835938 27.625 25.628906 C 20.6875 27.3125 13.496094 25.816406 12.351562 25.554688 C 12.042969 24.785156 11.886719 23.964844 11.890625 23.132812 L 11.953125 23.132812 C 11.953125 23.132812 20.175781 25.128906 28.003906 23.171875 Z M 28.109375 23.132812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.625 25.628906 C 26.628906 28 24.097656 29.644531 20.019531 29.644531 C 15.902344 29.644531 13.335938 27.960938 12.351562 25.554688 C 13.496094 25.816406 20.6875 27.3125 27.625 25.628906 Z M 27.625 25.628906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 58.999219 36 C 58.999219 48.705469 48.705469 58.999219 36 58.999219 C 23.294531 58.999219 13.000781 48.705469 13.000781 36 C 13.000781 23.294531 23.294531 13.000781 36 13.000781 C 48.705469 13.000781 58.999219 23.294531 58.999219 36 Z M 58.999219 36 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 50.596875 41.639062 C 50.603906 43.178906 50.308594 44.704687 49.725 46.132031 C 37.2375 49.1625 24.292969 46.469531 22.232812 45.998437 C 21.677344 44.613281 21.396094 43.136719 21.403125 41.639062 L 21.515625 41.639062 C 21.515625 41.639062 36.316406 45.232031 50.407031 41.709375 Z M 50.596875 41.639062 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 49.725 46.132031 C 47.932031 50.4 43.375781 53.360156 36.035156 53.360156 C 28.624219 53.360156 24.004687 50.329687 22.232812 45.998437 C 24.292969 46.469531 37.2375 49.1625 49.725 46.132031 Z M 49.725 46.132031 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 31.696875 32.407031 C 30.9375 30.698437 29.242969 29.594531 27.372656 29.594531 C 25.509375 29.594531 23.814844 30.698437 23.055469 32.407031 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 48.944531 32.407031 C 48.185156 30.698437 46.490625 29.594531 44.627344 29.594531 C 42.757031 29.594531 41.0625 30.698437 40.303125 32.407031 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.acc036d707e12cd7a3474c91a7798321.svg";
export { ForwardRef as ReactComponent };